// extracted by mini-css-extract-plugin
export default {"notFound":"Q4myvAo4dnLq69TAsuhp-NotFoundComponent-notFound"};